export { default } from "./ResultCounts";
